module.exports = __webpack_public_path__ + "static/media/anar.4117ab05.jpeg";